
import React, {useState} from "react";
import { BASE_URL } from "../../../constants";
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import {OverlayTrigger, Tooltip, Button, Row, Col, Container, Card, InputGroup} from 'react-bootstrap';
import '../../../CommonCSS/SocietyCSS.css';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import EditBudgetModal from './EditBdgtMasterModal';

const BudgetMaster = () => {

  const [mode, setMode] = useState("INITIAL");

  const isHeaderEnabled = (mode === "NEW" || mode === "EDIT");
  const isDetailsEnabled = (mode === "NEW" || mode === "EDIT");

  const isNewEnabled = (mode === "INITIAL");
  const isProceedEnabled = (mode === "NEW");
  const isSaveEnabled = (mode === "NEW" || mode === "EDIT");
  const [showsearchModal, setShowSearchModal] = useState(false);

  const [headerData, setHeaderData] = useState({
    budget_id: "",
    budget_name: "",
    active: "Y"
  });

  const [childRows, setChildRows] = useState([
    { sub_budget_name: "", sub_budget_id: "", active: "Y", 
      isNew: true,     // new row
      isDirty: false,  // modified row
      isDeleted: false // deleted row (optional)
     }
  ]);

  // Header Change
  const handleHeaderChange = (e) => {
    const { name, value } = e.target;
    setHeaderData(prev => ({ ...prev, [name]: value }));
  };

  // Child Change
  const handleChildChange = (index, e) => {
    const { name, value } = e.target;
    const updated = [...childRows];
    updated[index][name] = value;

    if (!updated[index].isNew) {
      updated[index].isDirty = true;
    }

    setChildRows(updated);
  };

  // Add Row
  const addRow = () => {
    setChildRows([...childRows, { sub_budget_name: "", sub_budget_id: "", active: "Y",
                                  isNew: true, isDirty: false,  isDeleted: false
     }]);
  };

  // Remove Row
  const removeRow = (index) => {
    // const updated = [...childRows];
    // updated.splice(index, 1);
    // setChildRows(updated);

    const updated = [...childRows];

    if (updated[index].isNew) {
      // New row → remove directly
      updated.splice(index, 1);
    } else {
      // Existing row → toggle delete
      updated[index].isDeleted = !updated[index].isDeleted;

      // Optional: if undo delete, also remove dirty flag
      if (!updated[index].isDeleted) {
        updated[index].isDirty = false;
      }
    }

    setChildRows(updated);

  };

  // Actions
  const handleNew = () => {
    setMode("NEW");
    setHeaderData({
      budget_id: "",
      budget_name: "",
      active: "Y"
    });
    setChildRows([{ sub_budget_name: "", sub_budget_id: "", active: "Y", isNew: true, isDirty: false,  isDeleted: false }]);
  };

  const handleClear = () => {
    if (window.confirm("Clear data?")) {
      resetPage();
    }
  };

  const resetPage = () => {

    setChildRows([]);

    setHeaderData({
      budget_id: "",
      budget_name: "",
      active: "Y"
    });

    setChildRows([{ sub_budget_name: "", sub_budget_id: "", active: "Y", isNew: true, isDirty: false,  isDeleted: false }]);

    setMode("INITIAL");

  }

  // const handleProceed = () => {
  //   if (!headerData.budget_name) {
  //     toast.error("Enter Budget Name");
  //     return;
  //   }
  //   setMode("PROCEED");
  // };

  const handleSave = async () => {

    if (!headerData.budget_name) {
      toast.error("Enter Budget Name");
      return;
    }

    const uniqueSubBud = new Set();

    for (let i = 0; i < childRows.length; i++) {

      if (uniqueSubBud.has(childRows[i].sub_budget_name)) {
        //setErrors({ rowErrors: { [i]: { kpi_id: true } } });
        toast.error(`Duplicate Sub-Budget at row ${i + 1}`);
        return;
      }

      uniqueSubBud.add(childRows[i].sub_budget_name);

    }

    const isConfirmed = window.confirm("Save Budget Master ?");
    if (!isConfirmed) return;

    const newRows = childRows.filter(r => r.isNew && !r.isDeleted);
    const updatedRows = childRows.filter(r => r.isDirty && !r.isDeleted);
    const deletedRows = childRows.filter(r => r.isDeleted && !r.isNew);

    const payload = {
      header: headerData,
      //details: childRows,
      insertedRows: newRows,
      updatedRows: updatedRows,
      deletedRows: deletedRows
    };

    try {

      const response = await axios.post(`${BASE_URL}/api/save_Budget_Master`, payload);

      if (response.data.message === '1') {
        toast.success(`Budget/Sub-Budget saved successfully`);
        resetPage();
      } else {
        toast.error(`Error saving KPI`);
      }

    } catch (err) {
      console.error(err);
      toast.error("Error saving template");
    }

//    setMode("INITIAL");
  };

  const handleBudgetRowSelect = async (selRow) => {

    setShowSearchModal(false);
    headerData.budget_id = selRow.bgt_id;

    const response = await axios.get(`${BASE_URL}/api/get_budget_ByIds`, { params: { p_Bdgt_Id: selRow.bgt_id } });

    setHeaderData({
      budget_id: response.data[0].bgt_id,
      budget_name: response.data[0].bgt_name,
      active: response.data[0].active,
    });

    setChildRows(response.data);
    setMode("EDIT");

  };

  return (
    <Container fluid className="p-3">

      {/* HEADER */}
      <Card className="p-3 mb-3">

        <Row className="mb-3">

          <Col md={6}>
            <InputGroup>
              <InputGroup.Text style={{ width: "150px" }}>
                Budget Name
              </InputGroup.Text>
              <input
                className="form-control"
                name="budget_name"
                value={headerData.budget_name}
                disabled={!isHeaderEnabled}
                onChange={handleHeaderChange}
              />
            </InputGroup>
          </Col>

          <Col md={2}>
            <InputGroup>
              <InputGroup.Text>Active</InputGroup.Text>
              <select
                className="form-select"
                name="active"
                value={headerData.active}
                disabled={!isHeaderEnabled}
                onChange={handleHeaderChange}
              >
                <option value="Y">Yes</option>
                <option value="N">No</option>
              </select>
            </InputGroup>
          </Col>

        </Row>

        {/* ACTION BUTTONS */}
        <div className="d-flex justify-content-end gap-2">

          <Button style={{ width: "130px" }} variant="primary" disabled={!isNewEnabled} onClick={handleNew}>
            New
          </Button>
          <Button
            style={{ width: "130px" }}
            variant="secondary"
            disabled={!isSaveEnabled}
            onClick={handleClear}
          >
            Clear
          </Button>

          <Button
            style={{ width: "130px" }}
            variant="primary"
            //onClick={handleEdit}
            onClick={() => setShowSearchModal(true)}
            disabled={!isNewEnabled}>Edit
          </Button>
          {showsearchModal && (
            <EditBudgetModal
              show={showsearchModal}
              handleClose={() => setShowSearchModal(false)}
              onRowSelect={handleBudgetRowSelect}
              // handleSave={handleSave}
            />
            )}
          <Button style={{ width: "130px" }} variant="success" disabled={!isSaveEnabled} onClick={handleSave}>
            Save
          </Button>

        </div>

      </Card>

      {/* SUB-BUDGET TABLE */}
      <Card className="p-3">

        <div style={{ minHeight: '220px' }} className="table-wrapper">

          <table style={{ maxHeight: '35px' }} className="responsive-table scty-custom-table">

            <thead>
              <tr>
                <th style={{ width: "5%", textAlign: "center" }}>#</th>
                <th style={{ width: "70%" }}>Sub Budget Name</th>
                <th style={{ width: "10%", textAlign: "center" }}>Active</th>
                <th style={{ width: "10%" }}></th>
              </tr>
            </thead>

            <tbody>

              {childRows.map((row, index) => (

                <tr key={index}
                  style={{
                    backgroundColor: row.isDeleted ? "#f8d7da" : "",
                    textDecoration: row.isDeleted ? "line-through" : "",
                    opacity: row.isDeleted ? 0.7 : 1
                  }}
                >

                  <td style={{ textAlign: "center" }}>{index + 1}</td>

                  <td>
                    <input
                      className="form-control"
                      name="sub_budget_name"
                      value={row.sub_budget_name}
                      disabled={!isDetailsEnabled}
                      onChange={(e) => handleChildChange(index, e)}
                    />
                  </td>

                  <td>
                    <select
                      className="form-select"
                      name="active"
                      value={row.active}
                      disabled={!isHeaderEnabled}
                      onChange={(e) => handleChildChange(index, e)}
                    >
                      <option value="Y">Yes</option>
                      <option value="N">No</option>
                    </select>
                  </td>

                  <td>
                    {childRows.length > 1 && (
                      <Button
                        variant="danger"
                        size="sm"
                        onClick={() => removeRow(index)} > {row.isDeleted ? "Undo" : "Delete"}
                      </Button>
                    )}
                  </td>

                </tr>

              ))}

            </tbody>

          </table>

        </div>

        {/* ADD BUTTON */}

        <div className="d-flex justify-content-end mt-2">
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="add-tooltip" style={{ backgroundColor: "#e9ecef" }}>Add Row</Tooltip>}
          >
            <Button
              variant="primary"
              onClick={addRow}
              disabled={!isDetailsEnabled}
              style={{
                width: "45px",
                height: "45px",
                borderRadius: "50%",
                padding: "0",
                fontSize: "30px"
              }}
            >
            +
          </Button>
          </OverlayTrigger>
        </div>

      </Card>

    </Container>
  );
};

export default BudgetMaster;
